module.exports = __webpack_public_path__ + "img/img-zuixinzixun@2x.dc1c2599.png";